import { render, staticRenderFns } from "./bindWechat.vue?vue&type=template&id=04ce72a2&scoped=true"
import script from "./bindWechat.vue?vue&type=script&lang=js"
export * from "./bindWechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce72a2",
  null
  
)

export default component.exports